// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PatientImageCard from './data'

export default function PatientImageCardFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PatientImageCard">
      <PatientImageCard {...props}>
        {children}
      </PatientImageCard>
    </Flow>
  )
}
